import React from 'react';
import AdminWebAPIUtils from 'utils/AdminWebAPIUtils';
import queryString from 'qs';
import CargomaticInput from 'components/v2/input';
import WhiteLabel from 'utils/whitelabel.js';
import zxcvbn from 'zxcvbn';
import PasswordComplexity from '../../v2/password-complexity';

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: '',
      valid: false,
      error: null,
      logo: '',
      createPassword : false
    };
  }

  componentDidMount = async () => {
    try {
      const logo = await WhiteLabel.getClientLogo();
      this.setState({ logo });
      let pathUrl = this.props.match?.url;
      if(pathUrl === '/createpassword'){
        this.setState({createPassword : true})
      }
    } catch (e) {
      console.error('login, failed to get signed URL: ', e);
    }
  }

  handlePasswordReset = () => {
    const query = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    AdminWebAPIUtils.resetPassword(query.token, this.state.newPassword, this.state.createPassword);
    this.setState({ error: 'Password Changed Successfully!' });
    this.props.history.push('/login');
  };

  _validateInput() {
    let error;
    let valid = false;
    const blacklist = ['secret', 'cargo1', 'cargo01', 'welcome1', 'cargomatic'];
    const { score } = zxcvbn(this.state?.newPassword);
    if (this.state.newPassword === this.state.confirmPassword) {
      if (this.state.newPassword.length < 6) {
        error = 'Your password must be at least 6 characters';
      } else if (
        blacklist.indexOf(this.state.newPassword.toLowerCase()) > -1 ||
        score < 2
      ) {
        error = 'Sorry, your password is too weak!';
      } else {
        error = null;
        valid = true;
      }
    } else {
      error = 'Your passwords must match!';
    }

    this.setState({ valid, error });
  }

  handleConfirmNewPassword = (value) => {
    this.setState({ confirmPassword: value }, () => {
      this._validateInput();
    });
  };

  handleNewPassword = (value) => {
    this.setState({ newPassword: value }, () => {
      this._validateInput();
    });
  };

  renderPasswordReset() {
    const { newPassword, confirmPassword, error } = this.state;

    return (
      <div className="login-wrapper">
        <div className="login-container">
          <div className="logo">
            <a target="blank" href="https://cargomatic.com">
              <img
                alt="Cargomatic"
                src={this.state.logo}
                style={{ height: 30 }}
              />
            </a>
          </div>
          <div className="mb-6 -mt-8">
            <h4 className="mb-2 font-medium text-gray-900">
              Password Requirements
            </h4>
            <ul className="px-6 text-gray-500 list-disc space-y-1">
              <li key="characters">Password must be at least 6 characters</li>
              <li key="match">
                Use at least 1 symbol, 1 number, and upper and lower case letters
              </li>
              <li key="match">Password complexity must be at least "fair"</li>
              <li key="match">Passwords must match</li>
            </ul>
          </div>
          {!!newPassword.length && (
            <PasswordComplexity password={newPassword} />
          )}
          <div className="mb-2">
            <CargomaticInput
              value={newPassword}
              label="New Password"
              info="Please enter a new password"
              onChange={this.handleNewPassword}
              name="new_password"
              type="password"
            />
          </div>
          <div className="mb-2">
            <CargomaticInput
              value={confirmPassword}
              label="Confirm Password"
              info="Please confirm your password"
              onChange={this.handleConfirmNewPassword}
              name="confirm_password"
              type="password"
            />
          </div>
          <div>
            <button
              className="flex items-center mr-5 text-white login-button button button-green w-35"
              onClick={this.handlePasswordReset}
              disabled={!this.state.valid}
            >
              {this.state.createPassword ? 'Create' : 'Reset'} Password
            </button>
          </div>
          <div className="link-container">
            {error && <p className="text-red-500">{error}</p>}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.renderPasswordReset()}</div>;
  }
}

export default PasswordReset;
